import { render, staticRenderFns } from "./PostalCodeSearchModal.vue?vue&type=template&id=543b1c4e&scoped=true"
import script from "./PostalCodeSearchModal.vue?vue&type=script&lang=js"
export * from "./PostalCodeSearchModal.vue?vue&type=script&lang=js"
import style0 from "./PostalCodeSearchModal.vue?vue&type=style&index=0&id=543b1c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543b1c4e",
  null
  
)

export default component.exports